import { createContext } from "react";

export const CurrentTimeContext = createContext(new Date(0));
